export const initValues = {
  volunteer: {
    firstName: '',
    lastName: '',
    email: '',
    language: new Set([]),
    period: new Set([]),
    function: new Set([]),
    birthdate: null,
    gsm: '',
    recurring: false,
    experience: '',
    motivation: '',
    siteLang: ''
  }
}

export const initErrors = {
  volunteer: {}
}

export const initComponentErrors = {
  volunteer: {}
}